export const APPLICATION_ID = '4622433e-604f-412e-b891-b85e8221cea2'
export const CLIENT_TOKEN = 'pubad998562da00db44d0f8822c86449c23'
export const SITE = 'datadoghq.eu'
export const SERVICE = 'rum-frontdesk-vue3'
